import {useState} from 'react'
import {useAsyncEffect, useIncrementState} from '@eitje/hooks'
import {backend} from '../index'

export const useGet = (endPoint, {skip, params = {}, watch, skipInitial} = {}) => {
	const [retries, retry] = useIncrementState()
	const [data, setData] = useState({})
	const [error, setError] = useState()
	const [loading, setLoading] = useState(true)

	useAsyncEffect(async () => {
		if (!skip && (!skipInitial || retries > 0)) {
			setLoading(true)
			const res = await backend.get(endPoint, params)

			if (res.ok) {
				setData(res.data)
			} else {
				setError(true)
			}

			setLoading(false)
		}
	}, [endPoint, skip, retries, watch])

	return {data, error, loading, retry}
}

export default useGet
